export const translations = {
    pl: require('./locales/pl.json')
};
